import NavItem from '../nav-link';

import {fireEnquireOpenEvent} from "../../overlay/enquire";

export default function OfficeEmpty() {
    return (
        <div className="office-empty">
            <div className="office-empty__image"></div>
            <div className="office-empty__content">
                <h3>Our DMC spaces are currently fully occupied, however, we have a wonderful co-working space available for you at DMC 02.</h3>
                <div className="office-empty-content__links">
                    <NavItem text="Find out more" slug="/co-working" color="yellow"/>
                    <NavItem text="Speak to us" color="yellow" onClick={() => fireEnquireOpenEvent(0)}/>
                </div>

                <img className="office-empty-content__star" src="/images/assets/stars/yellow-star.svg"/>
            </div>
        </div>
    )
}